import {
    createBadge,
    getBadge,
    getBadges,
    reactivateBadge,
    revokeBadge,
    updateBadge
} from '@/api/badges';

export default {
    namespaced: true,
    state: {
        badges: [],
        badgesMeta: {total: 0},
        // Total des badges de l'organisation courante, chargé sans peupler la liste : il sert
        // à afficher le compteur de l'onglet Badges avant même qu'on l'ait ouvert.
        badgesCount: null,
        // True when the org has a remote (SFTP) import: a hand-made badge is never revoked by
        // an import, but an imported file containing its NFC reclaims it (overwrites the holder).
        remoteImportEnabled: false,
        // Epoch-ms of the last time this org's badges were sent to its base stations (null if never).
        badgesPushedAt: null,
        badge: null,
    },
    getters: {
        BADGES(state) {
            return state.badges;
        },
        BADGES_META(state) {
            return state.badgesMeta;
        },
        BADGES_COUNT(state) {
            return state.badgesCount;
        },
        REMOTE_IMPORT_ENABLED(state) {
            return state.remoteImportEnabled;
        },
        BADGES_PUSHED_AT(state) {
            return state.badgesPushedAt;
        },
        BADGE(state) {
            return state.badge;
        },
    },
    mutations: {
        SET_BADGES(state, data) {
            state.badges = data;
        },
        SET_BADGES_META(state, data) {
            state.badgesMeta = data;
        },
        SET_BADGES_COUNT(state, data) {
            state.badgesCount = data;
        },
        SET_REMOTE_IMPORT_ENABLED(state, data) {
            state.remoteImportEnabled = data;
        },
        SET_BADGES_PUSHED_AT(state, data) {
            state.badgesPushedAt = data;
        },
        SET_BADGE(state, data) {
            state.badge = data;
        },
    },
    actions: {
        // Ne rend que le total, sans toucher à la liste affichée.
        GET_BADGES_COUNT(context, organizationId) {
            if (!organizationId) {
                context.commit('SET_BADGES_COUNT', null);
                return Promise.resolve(null);
            }
            return getBadges({organization_id: organizationId, per_page: 1})
                .then(response => {
                    const total = response?.meta?.total ?? null;
                    context.commit('SET_BADGES_COUNT', total);
                    return total;
                })
                .catch(() => {
                    context.commit('SET_BADGES_COUNT', null);
                    return null;
                });
        },
        GET_BADGES(context, filters) {
            return new Promise((resolve, reject) => {
                getBadges(filters).then(response => {
                    context.commit('SET_BADGES', response.data);
                    context.commit('SET_BADGES_META', response.meta);
                    context.commit('SET_REMOTE_IMPORT_ENABLED', !!response.remote_import_enabled);
                    context.commit('SET_BADGES_PUSHED_AT', response.badges_pushed_at || null);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GET_BADGE(context, reference) {
            return new Promise((resolve, reject) => {
                getBadge(reference).then(response => {
                    context.commit('SET_BADGE', response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        CREATE_BADGE(context, data) {
            return new Promise((resolve, reject) => {
                createBadge(data).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        UPDATE_BADGE(context, {reference, data}) {
            return new Promise((resolve, reject) => {
                updateBadge(reference, data).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        REVOKE_BADGE(context, reference) {
            return new Promise((resolve, reject) => {
                revokeBadge(reference).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        REACTIVATE_BADGE(context, reference) {
            return new Promise((resolve, reject) => {
                reactivateBadge(reference).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    },
};
